export const UPDATE_BATCH_NURSERY_SESSIONS = 'UPDATE_BATCH_NURSERY_SESSIONS'
export const UPDATE_BATCH_NURSERY_SESSIONS_SUCCESS = 'UPDATE_BATCH_NURSERY_SESSIONS_SUCCESS'
export const UPDATE_BATCH_NURSERY_SESSIONS_FAILED = 'UPDATE_BATCH_NURSERY_SESSIONS_FAILED'
